import { render, staticRenderFns } from "./Aggression.vue?vue&type=template&id=48264cc6&scoped=true&"
import script from "./Aggression.vue?vue&type=script&lang=js&"
export * from "./Aggression.vue?vue&type=script&lang=js&"
import style0 from "./Aggression.vue?vue&type=style&index=0&id=48264cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48264cc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VProgressLinear,VSkeletonLoader})
